import { Skeleton, Space } from 'antd';

export const TabItem = ({
    count,
    color,
    text,
    loading,
}: {
    count: number;
    color: string;
    text: string;
    loading?: boolean;
}) => (
    <Space direction="vertical" size={8} style={{ textAlign: 'left' }}>
        <span style={{ color: 'var(--gray-8)', fontSize: 14 }}>{text}</span>
        {loading ? (
            <Skeleton.Button active size="small" style={{ width: 30, height: 24 }} />
        ) : (
            <span style={{ fontSize: 24, color, fontWeight: 500 }}>{count.toString()}</span>
        )}
    </Space>
);
